var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailSecActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 37,
    viewBox: "0 0 43 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.7506 34.9982C37.3067 34.9982 41.0002 31.3047 41.0002 26.7486C41.0002 22.1925 37.3067 18.499 32.7506 18.499C28.1944 18.499 24.501 22.1925 24.501 26.7486C24.501 31.3047 28.1944 34.9982 32.7506 34.9982Z",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2496 34.9982C14.8057 34.9982 18.4992 31.3047 18.4992 26.7486C18.4992 22.1925 14.8057 18.499 10.2496 18.499C5.69347 18.499 2 22.1925 2 26.7486C2 31.3047 5.69347 34.9982 10.2496 34.9982Z",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.499 9.49985C18.499 7.84993 19.849 6.5 21.4989 6.5C23.1488 6.5 24.4987 7.84993 24.4987 9.49985",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.90039 22.999L8.30012 5.59982C9.05008 3.49993 11 2 13.2499 2C16.2497 2 18.4996 4.24989 18.4996 7.24974V25.9988",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1002 22.999L34.7005 5.59982C33.9505 3.49993 32.0006 2 29.7507 2C26.7509 2 24.501 4.24989 24.501 7.24974V25.9988",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4989 27.4987C23.1556 27.4987 24.4987 26.1556 24.4987 24.4989C24.4987 22.8421 23.1556 21.499 21.4989 21.499C19.8421 21.499 18.499 22.8421 18.499 24.4989C18.499 26.1556 19.8421 27.4987 21.4989 27.4987Z",
    stroke: "#48C2C5",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailSecActivity);
export default __webpack_public_path__ + "static/media/detail-sec-activity.358fc05711938d922ed5127623beb8f1.svg";
export { ForwardRef as ReactComponent };